import { State, Actions, PERFORM_SEARCH } from "./types";
import { Reducer } from "redux";

const defaultState: State = {
  gifsById: {},
  gifsOrder: [],
  zoomLevel: 3,
  rating: "G",
  pagination: {
    currentCount: 0,
    totalCount: 0
  },
  searchTerm: "",
  focusedGifId: null,
  error: null
};

const reducer: Reducer<State, Actions> = (state = defaultState, action) => {
  switch (action.type) {
    case "PERFORM_SEARCH":
      return {
        ...performSearch({ state, results: action.results }),
        searchTerm: action.searchTerm
      };
    case "LOAD_MORE":
      return performSearch({
        state,
        results: action.results,
        shouldAppendResults: true
      });
    case "SEARCH_FAILED":
      return {
        ...state,
        error: action.error
      };
    case "CHANGE_ZOOM_LEVEL":
      return {
        ...state,
        zoomLevel: action.size
      };
    case "CHANGE_RATING":
      return {
        ...state,
        rating: action.rating
      };
    case "FOCUS_GIF":
      return {
        ...state,
        focusedGifId: action.gifId
      };

    default:
      return state;
  }
};

function performSearch({
  state,
  results,
  shouldAppendResults
}: {
  state: State;
  results: PERFORM_SEARCH["results"];
  shouldAppendResults?: boolean;
}): State {
  const { gifsOrder, gifById } = buildSearchResults({ results });

  return {
    ...state,
    gifsById: {
      ...state.gifsById,
      ...gifById
    },
    gifsOrder: [
      ...new Set([
        ...(shouldAppendResults ? state.gifsOrder : []),
        ...gifsOrder
      ])
    ],
    pagination: {
      currentCount: state.pagination.currentCount + results.pagination.count,
      totalCount: results.pagination.total_count
    }
  };
}

function buildSearchResults({
  results
}: {
  results: PERFORM_SEARCH["results"];
}): { gifsOrder: State["gifsOrder"]; gifById: State["gifsById"] } {
  const gifsOrder: State["gifsOrder"] = [];
  const gifById: State["gifsById"] = {};

  results.data.forEach(({ images, id, title }) => {
    gifsOrder.push(id);
    gifById[id] = {
      previewStillUrl: images.downsized_still.url,
      previewSize: {
        width: parseInt(images.downsized_still.width, 10),
        height: parseInt(images.downsized_still.height, 10)
      },
      previewUrl: images.downsized.url,
      originalUrl: images.original.url,
      title
    };
  });

  return { gifsOrder, gifById };
}

export { reducer, defaultState };
